module.exports = __webpack_public_path__ + "img/sld_scb_27_t1_b1_green.364344ea.svg";